import React from 'react';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import compose from 'lodash/flowRight';
import { determineUserAccess } from '../../../permissions/userLevelAccess';

import PaidSearchCampaignController from './PaidSearchCampaignController';

import CURRENT_USER from '../../../GraphQl/Queries/CURRENT_USER';
import PAID_SEARCH_CAMPAIGN from '../../../GraphQl/Queries/PAID_SEARCH_CAMPAIGN';

import OverlaySpinner from '../../../../platform/shared/OverlaySpinner';

const PaidSearchCampaignLoader = (props) => {
  const { match, currentUser } = props;
  const { params } = match;
  const { id, campaignId } = params;

  const config = currentUser.permission;
  const orgConfig = determineUserAccess(config);

  const {
    data: paidSearchCampaign,
    loading: loadingCampaign,
    error: errorCampaign,
  } = useQuery(PAID_SEARCH_CAMPAIGN, {
    variables: { orgId: id, campaignId: campaignId },
  });

  if (errorCampaign) {
    console.error(errorCampaign);
  }

  if (loadingCampaign) return <OverlaySpinner />;

  return (
    <PaidSearchCampaignController
      paidSearchCampaign={paidSearchCampaign}
      orgConfig={orgConfig}
      {...props}
    >
      {props.children}
    </PaidSearchCampaignController>
  );
};

export default compose(
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  })
)(withRouter(PaidSearchCampaignLoader));
